import { render } from "./editlist.vue?vue&type=template&id=1ca25ee6&scoped=true"
import script from "./editlist.vue?vue&type=script&lang=js"
export * from "./editlist.vue?vue&type=script&lang=js"

import "./editlist.vue?vue&type=style&index=0&id=1ca25ee6&scoped=true&lang=scss"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca25ee6"]])

export default __exports__